var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDerivativesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    rx: 3.91304,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#41A1ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12V7.5C8 7.10218 8.15804 6.72064 8.43934 6.43934C8.72064 6.15804 9.10218 6 9.5 6H24.5C24.8978 6 25.2794 6.15804 25.5607 6.43934C25.842 6.72064 26 7.10218 26 7.5V12M21 15V18.5M17 10.5V18.5M13 12.5V18.5M8 18V22.5C8 22.8978 8.15804 23.2794 8.43934 23.5607C8.72064 23.842 9.10218 24 9.5 24H24.5C24.8978 24 25.2794 23.842 25.5607 23.5607C25.842 23.2794 26 22.8978 26 22.5V18",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerivativesIcon);
export default __webpack_public_path__ + "static/media/derivativesIcon.ce8af8a1d3e3fddbe364a71b78554eaf.svg";
export { ForwardRef as ReactComponent };